import React from 'react';
import TWRewardsLogo from './logo-tw-rewards.inline.svg';

export const TreatsLogo = () => {
  return <TWRewardsLogo role="img" />;
};
